import type { BirthDate } from '@makemydeal/dr-common-utils';

export const transformBirthDate = (dateOfBirth: string): BirthDate | undefined => {
    const dateStr = dateOfBirth.trim();

    // Handle ISO date format (YYYY-MM-DD or YYYY-M-D) with or without time component
    // This will skip timezone processing and just extract the date part
    const isoDateOnlyMatch = dateStr.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (isoDateOnlyMatch) {
        const [, year, month, day] = isoDateOnlyMatch;
        return {
            birthDay: day.padStart(2, '0'),
            birthMonth: month.padStart(2, '0'),
            birthYear: year
        };
    }

    // Handle US date format (M/D/YYYY or MM/DD/YYYY) — what the Interstate DatePicker emits
    const usMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (usMatch) {
        const [, month, day, year] = usMatch;
        return {
            birthDay: day.padStart(2, '0'),
            birthMonth: month.padStart(2, '0'),
            birthYear: year
        };
    }

    return undefined;
};
